<template>
    <div class="family-node">
        <div class="companion"
             :class="{noChildren:node.children.length===0,noParent:node.parent==='',more:checkMore(node)}"
             :style="'width:'+fullWidth+'px;height:'+fullHeight+'px;--spouseNum:'+node.spouse.length+';--parentNum:'+(parent.name===undefined?0:(parent.spouse.length+1))">
            <template v-if="parent.children">
                <el-tooltip class="item" effect="light" :disabled="!node.details" :content="node.details"
                            placement="top">
                    <div @click="$emit('toolMenu', node)" v-if="node!=null" class="node"
                         :class="{ 'first':checkIndex(node,familyTree)===0&&checkIndex(node,familyTree)!=parent.children.length-1,'last':checkIndex(node,familyTree)===parent.children.length-1&&checkIndex(node,familyTree)!=0,'max':node.spouse.length>parent.spouse.length,'single':checkIndex(node,familyTree)===parent.children.length-1&&checkIndex(node,familyTree)===0,'death': node.deathDate != ''&&node.deathDate != null,'male': node.gender === 'male', 'female': node.gender === 'female' }">
                        <div class="node-content">
                            <i class="tx" v-if="node.photo"><img :src="node.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            <span :style="whichStyle(node.name)">{{ node.name }}</span>
                        </div>
                    </div>
                </el-tooltip>
            </template>
            <template v-else>
                <el-tooltip class="item" effect="light" :disabled="!node.details" :content="node.details"
                            placement="top">
                    <div @click="$emit('toolMenu', node)" v-if="node!=null" class="node"
                         :class="{ 'first':checkIndex(node,familyTree)===0,'death': node.deathDate != ''&&node.deathDate != null,'male': node.gender === 'male', 'female': node.gender === 'female' }">
                        <div class="node-content">
                            <i class="tx" v-if="node.photo"><img :src="node.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            <span :style="whichStyle(node.name)">{{ node.name }}</span>
                        </div>
                    </div>
                </el-tooltip>
            </template>
            <div class="spouses">
                <div v-for="sp in node.spouse" @click="$emit('toolMenuS', sp)" class="node"
                     :class="{ 'death': sp.deathDate != ''&&sp.deathDate != null,'male': sp.gender === 'male', 'female': sp.gender === 'female' }">
                    <el-tooltip class="item" effect="light" :disabled="!sp.details" :content="sp.details"
                                placement="top">
                        <div class="node-content">
                            <i class="tx" v-if="sp.photo"><img :src="sp.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            <span :style="whichStyle(sp.name)">{{ sp.name }}</span>
                        </div>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div v-if="node!=null&&node.children.length>0" class="children">

            <family-node
                    v-for="child in node.children"
                    :key="child.id"
                    :node="child"
                    :direction="direction"
                    :type="type"
                    @toolMenu="$emit('toolMenu', $event)"
                    @toolMenuS="$emit('toolMenuS',$event)"
            />

        </div>
    </div>
</template>

<script>
    export default {
        name: 'FamilyNode',
        data() {
            return {
                familyTree: {},
                parent: {}
            }
        },
        props: {
            node: {
                type: Object,
                default() {
                    return {}
                }
            },
            direction: {
                type: String,
                default: 'vertical'
            },
            type: {
                type: String,
                default: 'square'
            },
        },
        created() {


        },
        mounted() {
            this.$nextTick(() => {
                this.$el.style.cssText = '--wf:' + this.$el.getBoundingClientRect().width + 'px;--hf:' + this.$el.getBoundingClientRect().height + 'px'
            })
            //this.$el.style.cssText = '--numSpouse:'+(this.$el.scrollWidth/40)+';--wf:' + this.$el.scrollWidth + 'px;--hf:' + this.$el.scrollHeight

            while (this.$root.$el.attributes.length > 0) {
                this.$root.$el.removeAttribute(this.$root.$el.attributes[0].name);
            }

            this.$root.$el.setAttribute('id', 'app')

            let directions = ['horizontal', 'vertical']
            if (directions.indexOf(this.direction) > -1) {
                this.$root.$el.setAttribute(this.direction, '')
            } else {
                this.$root.$el.setAttribute('vertical', '')
            }
            let shapes = ['square', 'round']
            if (shapes.indexOf(this.type) > -1) {
                this.$root.$el.setAttribute(this.type, '')
            } else {
                this.$root.$el.setAttribute('square', '')
            }


            this.familyTree = this.$root.$children[0].$children[0].familyTree


        },
        computed: {
            fullWidth() {
                if (this.direction != 'horizontal') {
                    let w
                    if (this.type != 'round') {
                        w = 40
                    } else {
                        w = 90
                    }
                    return (w * (this.node.spouse.length + 1))
                }

            },
            fullHeight() {
                if (this.direction === 'horizontal') {
                    let w
                    if (this.type != 'round') {
                        w = 40
                    } else {
                        w = 90
                    }
                    return (w * (this.node.spouse.length + 1))
                }

            },
        },
        methods: {
            checkMore(node) {
                let num1 = node.spouse.length + 1
                let num2 = node.children.length, num3 = 0
                node.children.forEach((el) => {
                    num3 += el.spouse.length
                })
                return num1 > num2 + num3

            },
            findNodeById(tree, id) {
                if (tree.id === id) {
                    return tree; // 找到匹配的节点，返回它
                } else if (tree.children) { // 检查是否有子节点
                    for (let child of tree.children) {
                        const result = this.findNodeById(child, id); // 递归搜索子节点
                        if (result) {
                            return result; // 如果在子节点中找到，返回该节点
                        }
                    }
                }
                return null; // 没有找到匹配的节点
            },
            checkIndex(node, data) {
                if (data.id) {
                    if (node.parent) {
                        let fi = this.findNodeById(data, node.parent)
                        this.parent = fi
                        const index = fi.children.indexOf(node)

                        return index
                    } else {
                        return 0
                    }
                }

            },
            whichStyle(name) {
                let len = name.length
                let fs = Math.floor(66 / len)
                if (fs < 18) {
                    if (this.direction != 'horizontal') {
                        return 'font-size:' + (fs - 2) + 'px;width:' + (fs - 2) + 'px'
                    } else {
                        return 'font-size:' + (fs - 2) + 'px;height:' + (fs - 2) + 'px'
                    }
                }
            }
        },
    }
</script>
<style>
    :root {
        --gap: 30px;
    }

    [vertical] {
        --direction: column;
        --directionC: row;
    }

    [horizontal] {
        --direction: row;
        --directionC: column;
    }

    [square][vertical] {
        --gew: 40px;
        --geh: 100px;
    }

    [square][horizontal] {
        --gew: 100px;
        --geh: 40px;
    }

    [round] {
        --gew: 90px;
        --geh: 90px;
    }
</style>
<style scoped>
    .family-node {
        display: flex;
        flex-direction: var(--direction);
        align-items: center;
        position: relative;
        gap: var(--gap);
    }

    .companion {
        position: relative;
        z-index: 2;
    }

    .companion:before {
        content: '';
        position: absolute;
        top: calc(var(--gap) * -0.5);
        left: calc(var(--gew) * 0.5);
        width: 1px;
        height: calc(var(--gap) * 0.5);
        background-color: var(--line);
    }

    [horizontal] .companion:before {
        left: calc(var(--gap) * -0.5);
        top: calc(var(--geh) * 0.5);
        height: 1px;
        width: calc(var(--gap) * 0.5);
    }


    .companion:after {
        content: '';
        position: absolute;
        top: var(--geh);
        left: calc(var(--gew) * 0.5);
        width: 1px;
        height: calc(var(--gap) * 0.5);
        background-color: var(--line);
    }

    [horizontal] .companion:after {
        top: calc(var(--geh) * 0.5);
        left: var(--gew);
        height: 1px;
        width: calc(var(--gap) * 0.5);
    }

    .companion.noParent:before {
        content: none;
    }

    .companion.noChildren:after {
        content: none;
    }


    .spouses {
        position: absolute;
        top: 0;
        transform: translateX(var(--gew));
        display: flex;
        flex-direction: var(--directionC);
    }

    [horizontal] .spouses {
        transform: translateX(0) translateY(var(--geh));
    }

    .more .spouses:before {
        content: '';
        position: absolute;
        top: calc(var(--geh) + var(--gap) * 0.5);
        left: calc(var(--gew) * -0.5);
        width: calc(var(--gew) * calc(var(--spouseNum) - 1) * 0.5);
        height: 1px;
        background-color: var(--line);
    }

    [horizontal] .more .spouses:before {
        left: calc(var(--gew) + var(--gap) * 0.5);
        top: calc(var(--geh) * -0.5);
        height: calc(var(--geh) * calc(var(--spouseNum) - 1) * 0.5);
        width: 1px;
    }

    .noChildren .spouses:before {
        content: unset;
    }


    .node {
        width: var(--gew);
        height: var(--geh);
        border-radius: calc(var(--gew) * 0.2);
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        transition: all .4s;
    }

    [round] .node {
        border-radius: 100%;
    }

    .node.single:before {
        content: '';
        width: calc(calc(var(--wf) * 0.5) - calc(var(--gew) * 0.5 * var(--spouseNum)));
        height: calc(var(--gap) * 0.5);
        background: var(--bg);
        position: absolute;
        transform: translate(calc((var(--parentNum) * var(--gew) - (var(--spouseNum) + 1) * var(--gew)) * -0.5 + var(--gew) * -0.5 + 1px), calc(var(--gap) * -0.5 - 1px));
        right: 0;
        top: 0;
    }

    [horizontal] .node.single:before {
        height: calc(calc(var(--hf) * 0.5) - calc(var(--geh) * 0.5 * var(--spouseNum)));
        width: calc(var(--gap) * 0.5);
        transform: translate(calc(var(--gap) * -0.5 - 1px), calc((var(--parentNum) * var(--geh) - (var(--spouseNum) + 1) * var(--geh)) * -0.5 + var(--geh) * -0.5 + 1px));
        left: 0;
        bottom: 0;
        right: unset;
        top: unset;
    }

    .node.single:after {
        content: '';
        width: calc(calc(var(--wf) * 0.5) + calc(var(--gew) * 0.5 * var(--spouseNum)));
        height: calc(var(--gap) * 0.5);
        background: var(--bg);
        position: absolute;
        transform: translate(calc(var(--gew) * 0.5), calc(var(--gap) * -0.5 - 1px));
        left: 0;
        top: 0;
    }

    [horizontal] .node.single:after {
        height: calc(calc(var(--hf) * 0.5) + calc(var(--geh) * 0.5 * var(--spouseNum)));
        width: calc(var(--gap) * 0.5);
        transform: translate(calc(var(--gap) * -0.5 - 1px), calc(var(--geh) * 0.5));

    }

    .node.single.max:before {
        transform: translate(calc(var(--gew) * -0.5 + 1px), calc(var(--gap) * -0.5 - 1px));
    }

    [horizontal] .node.single.max:before {
        transform: translate(calc(var(--gap) * -0.5 - 1px), calc(var(--geh) * -0.5 + 1px));
    }

    .node.single.max:after {
        transform: translate(calc((var(--parentNum) * var(--gew) - (var(--spouseNum) + 1) * var(--gew)) * -0.5 + var(--gew) * 0.5), calc(var(--gap) * -0.5 - 1px));
    }

    [horizontal] .node.single.max:after {
        transform: translate(calc(var(--gap) * -0.5 - 1px), calc((var(--parentNum) * var(--geh) - (var(--spouseNum) + 1) * var(--geh)) * -0.5 + var(--geh) * 0.5));
    }


    .node.first:before {
        content: '';
        width: calc(var(--wf) * 0.5);
        height: calc(var(--gap) * 0.5);
        background: var(--bg);
        position: absolute;
        transform: translate(calc(var(--gew) * -0.5 + 1px), calc(var(--gap) * -0.5 - 1px));
        right: 0;
    }

    [horizontal] .node.first:before {
        height: calc(var(--hf) * 0.5);
        width: calc(var(--gap) * 0.5);
        transform: translate(calc(var(--gap) * -0.5 - 1px), calc(var(--geh) * -0.5 + 1px));
        bottom: 0;
        left: 0;
    }

    .node.last:before {
        content: '';
        width: calc(var(--wf) - calc(var(--gew) * 0.5));
        height: calc(var(--gap) * 0.5);
        background: var(--bg);
        position: absolute;
        transform: translate(calc(var(--gew) * 0.5), calc(var(--gap) * -0.5 - 1px));
        left: 0;
    }

    [horizontal] .node.last:before {
        height: calc(var(--hf) - calc(var(--geh) * 0.5));
        width: calc(var(--gap) * 0.5);
        transform: translate(calc(var(--gap) * -0.5 - 1px), calc(var(--geh) * 0.5));
        top: 0;
    }


    .male {
        background-color: var(--mbg);
        border: 1px solid var(--mline);
    }

    .male i {
        color: var(--mtx);
    }

    .male span {
        color: var(--mwz);
    }

    .female {
        background-color: var(--fbg);
        border: 1px solid var(--fline);
    }

    .female i {
        color: var(--ftx);
    }

    .female span {
        color: var(--fwz);
    }


    .death {
        border-color: var(--deathline);
        background: var(--deathbg);
    }

    .death i, .death span {
        opacity: .5;
        color: var(--deathline);
    }

    .node-content {
        display: flex;
        flex-direction: var(--direction);
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    [round] .node-content {
        position: relative;
        flex-direction: column;
    }

    .node-content i {
        font-size: 32px;
        width: 32px;
        height: 32px;
    }

    .node-content i.tx {
        font-size: unset;
        border-radius: 100%;
        overflow: hidden;
    }
    [round] .node-content i {
        width: calc(var(--gew) * .5);
        height: calc(var(--geh) * .5);
        font-size: calc(var(--gew) * .5);
        display: flex;
        overflow: hidden;
        border-radius: 100%;
        margin-top: -25%;
    }

    [round] .node-content i.tx {
        width: calc(var(--gew) - 2px);
        height: calc(var(--geh) - 2px);
        font-size: calc(var(--gew) - 2px);
        margin-top: 0;
    }


    [round] .node-content i + span {
        width: 100% !important;
        height: fit-content;
        position: absolute;
        bottom: 0px;
        color: #fff;
        padding: 5px 0;
        border-radius: 5px;
        font-size: 16px;
    }
    [round] .male .node-content i + span{
         background: var(--mline);
     }
    [round] .female .node-content i + span{
        background: var(--fline);
    }

    .node-content i img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .node-content span {
        height: calc(100% - 32px);
        font-size: 18px;
        width: 18px;
        line-height: 1em;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
    }


    [horizontal] .node-content span {
        height: var(--geh);
        width: calc(100% - 32px);
    }


    .children {
        display: flex;
        flex-direction: var(--directionC);
        position: relative;
        gap: 15px;
        z-index: 1;
    }

    .children:before {
        content: '';
        position: absolute;
        top: calc(var(--gap) * -0.5);
        left: 0px;
        width: 100%;
        height: 1px;
        background-color: var(--line);
    }

    [horizontal] .children:before {
        left: calc(var(--gap) * -0.5);
        top: 0px;
        height: 100%;
        width: 1px;
    }


    @media (max-width: 768px) {

    }
</style>
